import React, {FC} from 'react';
import styled from 'styled-components';

import {AsyncStatusesEnum} from '../../../../../libs/shared/core/src/helpers/types/asyncStatuses';
import {AsyncLoader} from '../../../../../libs/shared/ui/src/components/loaders/asyncLoader';
import {center} from '../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface CellsFailedProps {
  onRetryClick: () => void;
}

/*
 * Style.
 */

const StyledLoaderDiv = styled.div`
  grid-row: 1 / span 3;
  grid-column: 1;
  min-width: 0;
  pointer-events: none;

  & > * {
    pointer-events: all;
  }

  ${center()};
`;

/*
 * Component.
 */

export const CellsFailed: FC<CellsFailedProps> = (props) => (
  <StyledLoaderDiv>
    <AsyncLoader
      status={AsyncStatusesEnum.FAILED}
      shouldHideRetryAfterReconnect
      onRetryClick={props.onRetryClick}
    />
  </StyledLoaderDiv>
);
